export default __webpack_public_path__ + "static/media/5.15614c57.png";